<template>
	<div>
		<form class="login" @submit.prevent="login">
			<h1>Sign in</h1>
			<label>Email</label>
			<input
				required
				v-model="email"
				type="text"
				placeholder="Snoopy"
			/>
			<label>Password</label>
			<input
				required
				v-model="password"
				type="password"
				placeholder="Password"
			/>
			<hr />
			<button type="submit">Login</button>
		</form>
	</div>
</template>

<style>
.login {
	display: flex;
	flex-direction: column;
	/* width: 300px;
	padding: 10px; */
}
</style>

<script>
import { AUTH_REQUEST } from '@/store/actions/auth';
export default {
	name: 'login',
	data() {
		return {
			email: 'user@example.com',
			password: 'password',
		};
	},
	methods: {
		login: function () {
			const { email, password } = this;
			this.$store
				.dispatch(AUTH_REQUEST, { email, password })
				.then(() => {
					this.$router.push('/');
				})
				.catch(error => {
					console.log(error);
				});
		},
	},
};
</script>
